import type { CSSProperties } from "react";

import { DropdownMenuContent } from "@tudigo-monorepo/web-tudigo-components";

import { useCurrentRefinementList } from "../../hooks/use-current-refinement-list";
import {
  algoliaRefinementAttributes,
  type AlgoliaRefinementAttributesKey,
  type RefinementAttributeList,
} from "../../models/algolia-refinement-attributes";
import { CustomRefinementList } from "./custom-refinement-list";
import type { SearchProjectsRefinementsProps } from "./search-projects-refinements";

const CLEAR_REFINEMENTS_BTN_WIDTH = 34;

export function RefinementListContent(props: {
  refinementList: RefinementAttributeList;
  onRefineItemChange: SearchProjectsRefinementsProps["onRefineItemChange"];
}) {
  const style = useRefinementListContentStyle(props.refinementList.key);

  return (
    <DropdownMenuContent
      side="bottom"
      className="max-h-40 min-w-fit overflow-y-auto"
      style={style}
    >
      <CustomRefinementList
        attribute={algoliaRefinementAttributes[props.refinementList.key]}
        refinementList={props.refinementList}
        onRefineItemChange={props.onRefineItemChange}
      />
    </DropdownMenuContent>
  );
}

function useRefinementListContentStyle(
  key: AlgoliaRefinementAttributesKey,
): CSSProperties {
  const { isRefined } = useCurrentRefinementList(key);

  if (isRefined) {
    return {
      width: `calc(var(--radix-popper-anchor-width) + ${CLEAR_REFINEMENTS_BTN_WIDTH}px)`,
      marginLeft: `${CLEAR_REFINEMENTS_BTN_WIDTH}px`,
    };
  }

  return { width: "var(--radix-popper-anchor-width)" };
}
